<script>
import { layoutMethods, layoutComputed } from "@/state/helpers";
import { SimpleBar } from "simplebar-vue3";
import axios from 'axios';
import i18n from "../i18n";
import {AwardIcon} from "@zhuowenli/vue-feather-icons";
import Swal from "sweetalert2";
import jwt_decode from "jwt-decode";
import _ from "lodash";
import { mapActions } from "vuex";

/**
 * Nav-bar Component
 */
export default {
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/us.svg"),
          language: "en",
          title: "English",
          value: 1,
        },
        {
          flag: require("@/assets/images/flags/spain.svg"),
          language: "sp",
          title: "Spanish",
          value: 2,
        },
      ],
      userPreferences: [],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
      myVar: 1,
      userFullName: localStorage.getItem('firstName') +' '+ localStorage.getItem('lastname'),
      userFirstName: localStorage.getItem('firstName'),
      profile: localStorage.getItem('profile'),
      list: [],
      assist: [],
      userID: localStorage.getItem('id'),
      searchQuery: '',
      searchResults: [],
      isSearching: false,
      searchLoading: false,
      notifications: [],
      unreadNotificationsCount: 0,
      notificationInterval: null,
      isFirstNotificationFetch: true,
      recentSearches: [
        { title: "how to setup", path: "/" },
        { title: "buttons", path: "/" }
      ],
      errors: [],
      metaConversations: [],
      metaUnreadCount: 0,
      metaPageId: null,
      // AI robot: each agent turns it on for their prospects and sets its working hours
      aiSchedule: { eligible: false, enabled: false, start_time: '08:00', end_time: '17:00', days: [0, 1, 2, 3, 4], timezone: '', now_local: '', open_now: false },
      aiScheduleSaving: false,
      aiScheduleMessage: '',
      aiScheduleError: false,
      aiStats: null,
      aiDays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    };
  },
  components: { SimpleBar, AwardIcon },
  methods: {
    ...layoutMethods,
    ...mapActions("metaChat", ["openChat"]),
    
    formatTimeAgo(dateString) {
      const date = new Date(dateString);
      const now = new Date();
      const diffMs = now - date;
      const diffMins = Math.floor(diffMs / 60000);
      if (diffMins < 60) return diffMins + 'm ago';
      const diffHours = Math.floor(diffMins / 60);
      if (diffHours < 24) return diffHours + 'h ago';
      return Math.floor(diffHours / 24) + 'd ago';
    },
    
    async checkMetaConnection() {
      const token = localStorage.getItem('jwt');
      if(!token) return;
      try {
        const res = await axios.post('/api/comm/meta/status', { token });
        if (res.data.status === 'connected' && res.data.page_id) {
            this.metaPageId = res.data.page_id;
            this.fetchMetaConversations();
            
            // Poll for new messages every 30 seconds
            setInterval(() => {
                this.fetchMetaConversations();
            }, 30000);
        }
      } catch (err) {
        console.error("Error checking meta connection:", err);
      }
    },
    
    async fetchMetaConversations() {
        if (!this.metaPageId) return;
        const token = localStorage.getItem('jwt');
        try {
            const res = await axios.post('/api/comm/meta/conversationsList', { 
                token: token,
                page_id: this.metaPageId
            });
            this.metaConversations = res.data;
            this.metaUnreadCount = this.metaConversations.filter(c => c.is_unread).length;
        } catch (err) {
            console.error("Error fetching meta conversations", err);
        }
    },
    
    openMetaChat(conv) {
        this.openChat({
            recipient_id: conv.contact_id,
            page_id: this.metaPageId,
            name: conv.contact_name || "Facebook User",
            contact_picture: conv.contact_picture,
            platform: conv.platform
        });
        // Mark as read locally
        conv.is_unread = false;
        this.metaUnreadCount = this.metaConversations.filter(c => c.is_unread).length;
    },

    fetchAiSchedule() {
        const token = localStorage.getItem('jwt');
        if (!token) return;
        axios.post('/api/ia/schedule', { token: token })
            .then(res => { this.aiSchedule = res.data; })
            .catch(err => console.log('Error fetching AI robot schedule:', err));
    },

    fetchAiStats() {
        // the agent's own robot numbers for the last 7 days (communication/ai_robot_stats.py)
        const token = localStorage.getItem('jwt');
        if (!token) return;
        axios.post('/api/ia/robot/stats', { token: token, mine: true })
            .then(res => { this.aiStats = res.data; })
            .catch(() => { this.aiStats = null; });
    },

    toggleAiDay(day) {
        const days = new Set(this.aiSchedule.days);
        if (days.has(day)) days.delete(day); else days.add(day);
        this.aiSchedule.days = Array.from(days).sort();
    },

    saveAiSchedule() {
        const token = localStorage.getItem('jwt');
        if (!token) return;
        this.aiScheduleSaving = true;
        this.aiScheduleMessage = '';
        axios.post('/api/ia/schedule', {
            token: token,
            action: 'save',
            enabled: this.aiSchedule.enabled,
            start_time: this.aiSchedule.start_time,
            end_time: this.aiSchedule.end_time,
            days: this.aiSchedule.days
        })
            .then(res => {
                this.aiSchedule = res.data;
                this.aiScheduleError = false;
                this.aiScheduleMessage = 'Saved';
            })
            .catch(err => {
                this.aiScheduleError = true;
                this.aiScheduleMessage = (err.response && err.response.data && err.response.data.error) || 'Could not save.';
            })
            .finally(() => { this.aiScheduleSaving = false; });
    },

    fetchNotifications() {
        const token = localStorage.getItem('jwt');
        if(!token) return;
        axios.post('/api/notifications', { token: token })
            .then(res => {
                if(res.data && res.data.notifications) {
                    this.notifications = res.data.notifications;
                    const newUnread = res.data.unread_count || 0;
                    
                    // Toast notification for new alerts
                    if (this.isFirstNotificationFetch) {
                        if (newUnread > 0) {
                            Swal.fire({
                                toast: true,
                                position: 'bottom-end',
                                icon: 'info',
                                title: 'You have pending notifications',
                                showConfirmButton: false,
                                timer: 3000,
                                customClass: { popup: 'swal-toast-raised' }
                            });
                        }
                        this.isFirstNotificationFetch = false;
                    } else if (newUnread > this.unreadNotificationsCount) {
                        Swal.fire({
                            toast: true,
                            position: 'bottom-end',
                            icon: 'info',
                            title: 'You have new notifications',
                            showConfirmButton: false,
                            timer: 3000,
                            customClass: { popup: 'swal-toast-raised' }
                        });
                    }
                    this.unreadNotificationsCount = newUnread;
                }
            })
            .catch(err => console.log('Error fetching notifications:', err));
    },
    markNotificationsRead(action, notifId = null) {
        const token = localStorage.getItem('jwt');
        if(!token) return;
        const payload = { token: token, action: action };
        if (notifId) payload.notification_id = notifId;
        
        axios.post('/api/notifications', payload)
            .then(() => {
                this.fetchNotifications();
            })
            .catch(err => console.log('Error marking notifications read:', err));
    },
    showNotification(notif) {
        Swal.fire({
            title: notif.title,
            html: `<p style="font-size:1rem; line-height:1.6; text-align:left;">${notif.message}</p>
                   <p class="text-muted" style="font-size:0.78rem; text-align:left; margin-top:12px;"><i class="mdi mdi-clock-outline"></i> ${this.formatNotifDate(notif.createdOn)}</p>`,
            icon: 'info',
            confirmButtonText: 'Mark as Read',
            showCancelButton: true,
            cancelButtonText: 'Close',
            confirmButtonColor: '#3085d6'
        }).then((result) => {
            if (result.isConfirmed) {
                this.markNotificationsRead('read_one', notif.id);
            }
            if (notif.link && notif.link !== '#' && result.isConfirmed) {
                window.location.href = notif.link;
            }
        });
    },
    formatNotifDate(dateStr) {
        if (!dateStr) return '';
        const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        // Parse as UTC from backend, convert to local
        const d = new Date(dateStr.replace(' ', 'T') + 'Z');
        const month = months[d.getMonth()];
        const day = d.getDate();
        const year = d.getFullYear();
        let hours = d.getHours();
        const minutes = String(d.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        return `${month} ${day} ${year} ${hours}:${minutes} ${ampm}`;
    },
    isCustomDropdown() {
      //Search bar
      var searchOptions = document.getElementById("search-close-options");
      var dropdown = document.getElementById("search-dropdown");
      var searchInput = document.getElementById("search-options");

      if (searchInput && searchOptions && dropdown) {
          searchInput.addEventListener("focus", () => {
            var inputLength = searchInput.value.length;
            if (inputLength > 0) {
          dropdown.classList.add("show");
          searchOptions.classList.remove("d-none");
        } else {
          dropdown.classList.remove("show");
          searchOptions.classList.add("d-none");
        }
      });

      searchInput.addEventListener("keyup", () => {
        var inputLength = searchInput.value.length;
        if (inputLength > 0) {
          dropdown.classList.add("show");
          searchOptions.classList.remove("d-none");
        } else {
          dropdown.classList.remove("show");
          searchOptions.classList.add("d-none");
        }
      });

      searchOptions.addEventListener("click", () => {
        searchInput.value = "";
        dropdown.classList.remove("show");
        searchOptions.classList.add("d-none");
      });

      document.body.addEventListener("click", (e) => {
        if (e.target.getAttribute("id") !== "search-options") {
          dropdown.classList.remove("show");
          searchOptions.classList.add("d-none");
        }
      });
      }
    },
    toggleHamburgerMenu() {
      var windowSize = document.documentElement.clientWidth;

      if (windowSize > 767)
        document.querySelector(".hamburger-icon").classList.toggle("open");

      //For collapse horizontal menu
      if (
        document.documentElement.getAttribute("data-layout") === "horizontal"
      ) {
        document.body.classList.contains("menu")
          ? document.body.classList.remove("menu")
          : document.body.classList.add("menu");
      }

      //For collapse vertical menu
      if (document.documentElement.getAttribute("data-layout") === "vertical") {
        if (windowSize < 1025 && windowSize > 767) {
          document.body.classList.remove("vertical-sidebar-enable");
          document.documentElement.getAttribute("data-sidebar-size") == "sm"
            ? document.documentElement.setAttribute("data-sidebar-size", "")
            : document.documentElement.setAttribute("data-sidebar-size", "sm");
        } else if (windowSize > 1025) {
          document.body.classList.remove("vertical-sidebar-enable");
          document.documentElement.getAttribute("data-sidebar-size") == "lg"
            ? document.documentElement.setAttribute("data-sidebar-size", "sm")
            : document.documentElement.setAttribute("data-sidebar-size", "lg");
        } else if (windowSize <= 767) {
          document.body.classList.add("vertical-sidebar-enable");
          document.documentElement.setAttribute("data-sidebar-size", "lg");
        }
      }

      //Two column menu
      if (document.documentElement.getAttribute("data-layout") == "twocolumn") {
        document.body.classList.contains("twocolumn-panel")
          ? document.body.classList.remove("twocolumn-panel")
          : document.body.classList.add("twocolumn-panel");
      }
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      this.updateUserPreferences('language', this.lan)
      const langImg = document.getElementById("header-lang-img");
      if (langImg) {
        langImg.setAttribute("src", flag);
      }
      i18n.global.locale = locale;
    },
    async toggleDarkMode() {
      if (document.documentElement.getAttribute("data-layout-mode") == "dark") {
        document.documentElement.setAttribute("data-layout-mode", "light");
        await this.updateUserPreferences('nightMode', 'light')
        location.reload();
      } else {
        document.documentElement.setAttribute("data-layout-mode", "dark");
        await this.updateUserPreferences('nightMode', 'dark')
        location.reload();
      }
    },
    async logout() {
       await axios
           .post('/api/logout')
           .then(response => {
             console.log(response)
           })
           .catch(error =>{
             console.log(JSON.stringify(error))
           })

      axios.defaults.headers.common['Authorization'] = ''
      localStorage.removeItem('jwt')
      this.$store.commit('removeToken')
    },
    async updateUserPreferences(preference, mode) {

      const data = {
        token: localStorage.getItem('jwt'),
        preference: preference,
        mode: mode
      }

      localStorage.setItem(preference, mode)
      await axios
          .post('/api/updatePreferences', data)
          .catch(error =>{
            console.log(JSON.stringify(error))
          })
    },
    async getPreferences(){
      const data = {
        token: localStorage.getItem('jwt'),
        userID: localStorage.getItem('id'),
      }

      axios
          .post('/api/getPreferences', data)
          .then(response => {
            let languageEng = this.languages[0]
            let languageSpa = this.languages[1]
            this.userPreferences = JSON.parse(response.data[0].json);

            // Language preferences
            if(languageEng.language === this.userPreferences.language) {
              this.setLanguage(this.userPreferences.language, languageEng.title, languageEng.flag)
            } else {
              this.setLanguage(this.userPreferences.language, languageSpa.title, languageSpa.flag)
            }

            localStorage.setItem('language', this.userPreferences.language)

            // Dark mode preferences
            if (this.userPreferences.nightMode === 'dark') {
              document.documentElement.setAttribute("data-layout-mode", "dark");
              document.documentElement.setAttribute("data-sidebar", "dark");
              document.documentElement.setAttribute("data-topbar", "dark");

              setTimeout(() => {
                document.documentElement.setAttribute("data-sidebar", "dark");
              }, 200);
            } else {
              document.documentElement.setAttribute("data-layout-mode", "light");
              document.documentElement.setAttribute("data-sidebar", "light");
              document.documentElement.setAttribute("data-topbar", "light");

              setTimeout(() => {
                document.documentElement.setAttribute("data-sidebar", "light");
                document.documentElement.setAttribute("data-topbar", "light");
              }, 100);
            }
            localStorage.setItem('nightMode', this.userPreferences.nightMode)
          })
          .catch(error => {
            if (error.response) {

              if(error.response.data.detail === 'Your session is expired!'){
                window.location.href = '/logout'
              }

              for (const property in error.response.data) {
                this.errors.push(`${property}: ${error.response.data[property]}`)
              }
            }
          })
    },
    async getBootcampInfo(){

      const data = {
        token: localStorage.getItem('jwt'),
        isActiveState: 1,
        userID: localStorage.getItem('id')
      }

      axios
          .post('/api/getBootcamp', data)
          .then(response => {

            this.list= response.data;
            this.assist= JSON.parse(response.data.assistanceJson)
            this.listQty = this.list.length
            this.page = 1
            this.setPages();
          })
          .catch(error => {
            if (error.response) {

              if(error.response.data.detail === 'Your session is expired!'){
                window.location.href = '/logout'
              }

              // for (const property in error.response.data) {
              // this.errors.push(`${property}: ${error.response.data[property]}`)
              // }
            } else if (error.message) {
              this.errors.push('Something was wrong, please contact your SysAdmin.')
            }
          })
    },
    async updateAssistance(userID=0, dayID=0, conditional=false){
      this.errors = []
      if (!this.errors.length) {
        const data = {
          token: localStorage.getItem('jwt'),
          userID: userID,
          dayID: dayID,
          conditional: conditional,
        }

        await axios
            .post('/api/updateAssistance', data)
            .then(async response => {
              if (response.status === 200) {
                await Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: 'Assistance day '+ (parseInt(dayID)+1) +' updated!'
                });
              }
            })
            .catch(async error => {
              if (error.response) {

                if(error.response.data.detail === 'Your session is expired!'){
                  window.location.href = '/logout'
                }

                let list = '';
                for (const property in error.response.data) {
                  this.errors.push(`${property}: ${error.response.data[property]}`)
                  list += '\n' + '<b>' + error.response.data[property] + '</b>';
                }

                await Swal.fire({
                  title: "Please check the following: " + list,
                  icon: 'warning',
                  confirmButtonClass: "btn btn-info",
                  buttonsStyling: false,
                  showCloseButton: true,
                });

              } else if (error.message) {
                this.errors.push('Something was wrong, please contact your SysAdmin.')
              }
            })
      } else {
        let list = '';
        for (let i = 0; i < this.errors.length; i++)
          list += '\n' + '<b>' + this.errors[i] + '</b>';

        await Swal.fire({
          title: "Please complete the form! " + list,
          icon: 'warning',
          confirmButtonClass: "btn btn-info",
          buttonsStyling: false,
          showCloseButton: true,
        });
      }
    },
    isJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    checkBootcampVisibility(){
      let value = localStorage.getItem('sID')
      if (value === '3' || value === '4'){
        return true
      }else{
        return false
      }

    },
    viewUserGroup(request) {
      const jwt = localStorage.getItem('jwt');
      if (!jwt) return false;
      try {
        const currentRole = jwt_decode(jwt);
        return currentRole.userGroup && currentRole.userGroup.includes(request);
      } catch (e) {
        return false;
      }
    },
    isRecruiter() {
      const jwt = localStorage.getItem('jwt');
      if (!jwt) return false;
      try {
        const decoded = jwt_decode(jwt);
        return decoded.isRecruiter === 1; // Assuming isRecruiter is directly on the token
      } catch (e) {
        return false;
      }
    },
    async searchGlobal() {
      if (!this.searchQuery || this.searchQuery.length < 3) {
        this.searchResults = [];
        this.isSearching = false;
        return;
      }

      this.isSearching = true;
      this.searchLoading = true;
      this.searchResults = [];

      const commonSearchValues = {
          keyword: this.searchQuery,
          language: '3',
          status: '0',
          sortBy: 'name',
          orderBy: 'ASC',
          dateRange: '0',
          department: '0',
          toDate: new Date().toLocaleDateString('en-us', { year: "numeric", month: "long", day: "numeric" }),
          fromDate: new Date(new Date().setFullYear(new Date().getFullYear() - 5)).toLocaleDateString('en-us', { year: "numeric", month: "long", day: "numeric" })
      };

      // Payload for Clients/Prospects
      const clientSearchParams = {
        token: localStorage.getItem('jwt'),
        searchValues: {
          ...commonSearchValues,
          type: '0',
          noteSearch: '',
          clients: 1,
        },
        userEmail: localStorage.getItem('email'),
        userID: localStorage.getItem('id'),
        deleted: 0,
        agentSearch: [],
        page: 1,
        perPage: 5
      };

      // Payload for Agents (Strictly matching working example)
      const agentSearchParams = {
        token: localStorage.getItem('jwt'),
        isProspect: 0,
        searchValues: {
          ...commonSearchValues,
          source: '0',
          isActive: 1,
          noteSearch: '',
          licensed: '1',
          statesList: 'ALL',
          fromDate: new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toLocaleDateString('en-us', { year: "numeric", month: "long", day: "numeric" })
        },
        userEmail: localStorage.getItem('email'),
        userID: localStorage.getItem('id')
      };

      try {
        // Search Clients
        const clientReq = axios.post('/api/client/listClients', { ...clientSearchParams, isProspect: 0 });
        // Search Prospects
        const prospectReq = axios.post('/api/client/listClients', { ...clientSearchParams, isProspect: 1 });
        // Search Agents
        const agentReq = axios.post('/api/listAgents', agentSearchParams); 

        const [clientRes, prospectRes, agentRes] = await Promise.all([clientReq, prospectReq, agentReq]);

        const clients = clientRes.data.results ? clientRes.data.results.map(c => ({...c, type: 'Client', route: { path: '/client/List', query: { client_id: c.ID } }, id: c.ID})) : [];
        const prospects = prospectRes.data.results ? prospectRes.data.results.map(p => ({...p, type: 'Prospect', route: { path: '/prospects/List', query: { prospect_id: p.ID } }, id: p.ID})) : [];
        
        // Handle Agent Response (might be array directly or object with results)
        let agents = [];
        if (Array.isArray(agentRes.data)) {
           agents = agentRes.data.map(a => ({...a, type: 'Agent', route: { path: '/agents/List', query: { agent_id: a.ID } }, id: a.ID}));
        } else if (agentRes.data.results) {
           agents = agentRes.data.results.map(a => ({...a, type: 'Agent', route: { path: '/agents/List', query: { agent_id: a.ID } }, id: a.ID}));
        }

        this.searchResults = [...clients, ...prospects, ...agents];
      } catch (error) {
        console.error("Search failed", error);
      } finally {
        this.searchLoading = false;
      }
    },
    formatPhone(phone) {
      if (!phone) return '';
      const x = phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    }
  },
  mounted() {
    this.checkMetaConnection();
    this.fetchNotifications();
    this.fetchAiSchedule();
    this.notificationInterval = setInterval(this.fetchNotifications, 60000);
    this.getBootcampInfo()

    if (document.getElementById("topnav-hamburger-icon"))
      document
          .getElementById("topnav-hamburger-icon")
          .addEventListener("click", this.toggleHamburgerMenu);

    this.isCustomDropdown();

    if(localStorage.getItem('language') === null || localStorage.getItem('nightMode') === null){
      this.getPreferences();
    }else{
      let languageEng = this.languages[0]
      let languageSpa = this.languages[1]
      let language = localStorage.getItem('language');

      // Language preferences
      if(languageEng.language === language) {
        this.setLanguage(language, languageEng.title, languageEng.flag)
      } else {
        this.setLanguage(language, languageSpa.title, languageSpa.flag)
      }

      let nightMode = localStorage.getItem('nightMode');
      // Dark mode preferences
      if (nightMode === 'dark') {
        document.documentElement.setAttribute("data-sidebar", "dark");
        document.documentElement.setAttribute("data-topbar", "dark");
        document.documentElement.setAttribute("data-layout-mode", "dark");
        setTimeout(() => {
          document.documentElement.setAttribute("data-sidebar", "dark");
        }, 200);
      } else {
        document.documentElement.setAttribute("data-topbar", "light");
        document.documentElement.setAttribute("data-layout-mode", "light");
        document.documentElement.setAttribute("data-sidebar", "light");

        setTimeout(() => {
          document.documentElement.setAttribute("data-sidebar", "light");
          document.documentElement.setAttribute("data-topbar", "light");
        }, 100);
      }
    }
  },
  beforeUnmount() {
    if (this.notificationInterval) {
        clearInterval(this.notificationInterval);
    }
  },
  computed: {
    ...layoutComputed,
    aiRobotStatus() {
      if (!this.aiSchedule.enabled) return { dot: 'bg-secondary', label: 'Off - the robot is not messaging your prospects' };
      if (this.aiSchedule.open_now) return { dot: 'bg-success', label: 'On - working now' };
      return { dot: 'bg-warning', label: 'On - outside your hours right now' };
    },
    layoutType: {
      get() {
        return this.$store ? this.$store.state.layout.layoutType : {} || {};
      },
      set(layout) {
        localStorage.setItem("rightbar_isopen", true);
        this.changeLayoutType({
          layoutType: layout,
        });
      },
    },
    layoutWidth: {
      get() {
        return this.$store ? this.$store.state.layout.layoutWidth : {} || {};
      },
      set(width) {
        this.changeLayoutWidth({
          layoutWidth: width,
        });
      },
    },
    topbar: {
      get() {
        return this.$store ? this.$store.state.layout.topbar : {} || {};
      },
      set(topbar) {
        this.changeTopbar({
          topbar: topbar,
        });
      },
    },
    sidebarSize: {
      get() {
        return this.$store ? this.$store.state.layout.sidebarSize : {} || {};
      },
      set(type) {
        return this.changeSidebarSize({
          sidebarSize: type,
        });
      },
    },
    position: {
      get() {
        return this.$store ? this.$store.state.layout.position : {} || {};
      },
      set(position) {
        return this.changePosition({
          position: position,
        });
      },
    },
    sidebarView: {
      get() {
        return this.$store ? this.$store.state.layout.sidebarView : {} || {};
      },
      set(sidebarView) {
        return this.changeSidebarView({
          sidebarView: sidebarView,
        });
      },
    },
    sidebarColor: {
      get() {
        return this.$store ? this.$store.state.layout.sidebarColor : {} || {};
      },
      set(sidebarColor) {
        return this.changeSidebarColor({
          sidebarColor: sidebarColor,
        });
      },
    },
    mode: {
      get() {
        return this.$store ? this.$store.state.layout.mode : {} || {};
      },
      set(mode) {
        return this.changeMode({
          mode: mode,
        });
      },
    },
    canViewSearch() {
      // Allow search for specific groups: Admins (SUPER_ADMIN_GROUP), Leaders (ADMIN_GROUP), Recruiters (isRecruiter)
      if (this.viewUserGroup('SUPER_ADMIN_GROUP') || this.viewUserGroup('ADMIN_GROUP') || this.isRecruiter()) {
        return true;
      }
      return false;
    }
  },
  watch:{
    searchQuery: _.debounce(function() {
      this.searchGlobal();
    }, 500)
  }
};
</script>
<style>
@media print {
  html, body {
    display: none;  /* hide whole page */
  }
}

[data-title]:hover:after {
  opacity: 1;
  transition: all 0.1s ease 0.5s;
  visibility: visible;
}
[data-title]:after {
  content: attr(data-title);
  position: absolute;
  bottom: -1.6em;
  left: 100%;
  padding: 4px 4px 4px 8px;
  color: #222;
  white-space: nowrap;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-box-shadow: 0px 0px 4px #222;
  -webkit-box-shadow: 0px 0px 4px #222;
  box-shadow: 0px 0px 4px #222;
  background-image: -moz-linear-gradient(top, #f8f8f8, #cccccc);
  background-image: -webkit-gradient(linear,left top,left bottom,color-stop(0, #f8f8f8),color-stop(1, #cccccc));
  background-image: -webkit-linear-gradient(top, #f8f8f8, #cccccc);
  background-image: -moz-linear-gradient(top, #f8f8f8, #cccccc);
  background-image: -ms-linear-gradient(top, #f8f8f8, #cccccc);
  background-image: -o-linear-gradient(top, #f8f8f8, #cccccc);
  opacity: 0;
  z-index: 99999;
  visibility: hidden;
}
[data-title] {
  position: relative;
}
</style>

<template>
  <header id="page-topbar">
    <div class="layout-width">
      <div class="navbar-header">
        <div class="d-flex">
          <!-- LOGO -->
          <div class="navbar-brand-box horizontal-logo">
            <router-link to="/" class="logo logo-dark">
              <span class="logo-sm">
                <img src="@/assets/images/logo-sm.png" alt="" height="22" />
              </span>
              <span class="logo-lg">
                <img src="@/assets/images/logo-dark.png" alt="" height="17" />
              </span>
            </router-link>

            <router-link to="/" class="logo logo-light">
              <span class="logo-sm">
                <img src="@/assets/images/logo-sm.png" alt="" height="22" />
              </span>
              <span class="logo-lg">
                <img src="@/assets/images/logo-light.png" alt="" height="17" />
              </span>
            </router-link>
          </div>

          <button
            type="button"
            class="
              btn btn-sm
              px-3
              fs-16
              header-item
              vertical-menu-btn
              topnav-hamburger
            "
            id="topnav-hamburger-icon"
          >
            <span class="hamburger-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>

          <!-- App Search-->
          <form class="app-search d-none d-md-block" v-if="canViewSearch" @submit.prevent>
            <div class="position-relative">
              <input
                type="text"
                class="form-control"
                placeholder="Search Clients & Prospects..."
                autocomplete="off"
                id="search-options"
                v-model="searchQuery"
              />
              <span class="mdi mdi-magnify search-widget-icon"></span>
              <span
                class="
                  mdi mdi-close-circle
                  search-widget-icon search-widget-icon-close
                  d-none
                "
                id="search-close-options"
                @click="searchQuery = ''; searchResults = []"
              ></span>
            </div>
            <div class="dropdown-menu dropdown-menu-lg" id="search-dropdown">
              <SimpleBar data-simplebar style="max-height: 320px">
                
                <!-- Loading State -->
                <div v-if="searchLoading" class="text-center py-3">
                  <div class="spinner-border text-primary avatar-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>

                <!-- Results -->
                <div v-else-if="searchResults.length > 0">
                  <div class="dropdown-header">
                    <h6 class="text-overflow text-muted mb-0 text-uppercase">
                      Search Results
                    </h6>
                  </div>

                  <router-link
                    v-for="(result, index) in searchResults"
                    :key="index"
                    :to="result.route" 
                    class="dropdown-item notify-item"
                  >
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar-xs">
                          <span class="avatar-title rounded-circle fs-16" 
                                :class="{
                                  'bg-soft-success text-success': result.type === 'Client',
                                  'bg-soft-warning text-warning': result.type === 'Prospect',
                                  'bg-soft-info text-info': result.type === 'Agent'
                                }">
                            {{ result.firstName ? result.firstName.charAt(0) : 'U' }}
                          </span>
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <h6 class="m-0">{{ result.firstName }} {{ result.lastName }}</h6>
                        <span class="fs-11 mb-0 text-muted">{{ formatPhone(result.phoneNumber) }} • {{ result.type }}</span>
                      </div>
                    </div>
                  </router-link>
                </div>

                <!-- No Results / Default View -->
                <div v-else>
                    <div v-if="searchQuery.length > 2" class="text-center py-3 text-muted">
                        No results found
                    </div>
                    <div v-else>
                        <!-- Recent Searches (Static for now) -->
                        <div class="dropdown-header">
                        <h6 class="text-overflow text-muted mb-0 text-uppercase">
                            Recent Searches
                        </h6>
                        </div>
                        <div class="dropdown-item bg-transparent text-wrap">
                        <router-link
                            v-for="(item, index) in recentSearches"
                            :key="index"
                            :to="item.path"
                            class="btn btn-soft-secondary btn-sm btn-rounded me-1"
                            >{{ item.title }} <i class="mdi mdi-magnify ms-1"></i
                        ></router-link>
                        </div>
                    </div>
                </div>

              </SimpleBar>
            </div>
          </form>
        </div>

        <div class="d-flex align-items-center">
          <div class="dropdown d-md-none topbar-head-dropdown header-item" v-if="canViewSearch">
            <button
              type="button"
              class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
              id="page-header-search-dropdown"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="bx bx-search fs-22"></i>
            </button>
            <div
              class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
              aria-labelledby="page-header-search-dropdown"
            >
              <form class="p-3">
                <div class="form-group m-0">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search ..."
                      aria-label="Recipient's username"
                    />
                    <button class="btn btn-primary" type="submit">
                      <i class="mdi mdi-magnify"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>


          <div class="dropdown ms-1 topbar-head-dropdown header-item" v-if="checkBootcampVisibility()">
            <button
                type="button"
                class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
              <AwardIcon></AwardIcon>
            </button>
            <div class="dropdown-menu dropdown-menu-end">
              <a class="dropdown-icon-item"
                 data-bs-toggle="modal"
                 href="#bootcampModal"
              >
                <span class="badge badge-pill bg-warning" data-key="t-new">Bootcamp Assistance</span>
              </a>
            </div>
          </div>
          
          <!-- Meta Messages Trigger -->
          <div class="ms-1 topbar-head-dropdown header-item" v-if="metaPageId">
            <button
              type="button"
              class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle position-relative"
              data-bs-toggle="offcanvas"
              data-bs-target="#metaMessengerSidebar"
              aria-controls="metaMessengerSidebar"
              @click="fetchMetaConversations()"
            >
              <i class="bx bxl-messenger fs-22"></i>
              <span v-if="metaUnreadCount > 0" class="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">
                {{ metaUnreadCount }}<span class="visually-hidden">unread messages</span>
              </span>
            </button>
          </div>
          <!-- End Meta Messages Trigger -->
              
          <!-- AI Robot: each agent turns it on for their prospects and sets the hours it may message them.
               Only shown to agents listed in some robot's "Limit to Agent / Recruiter" (eligible). -->
          <div v-if="aiSchedule.eligible" class="dropdown ms-1 topbar-head-dropdown header-item">
            <button
              type="button"
              class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle position-relative"
              data-bs-toggle="dropdown"
              data-bs-auto-close="outside"
              aria-haspopup="true"
              aria-expanded="false"
              title="AI Robot schedule"
              @click="fetchAiSchedule(); fetchAiStats()"
            >
              <i class="ri-robot-line fs-22"></i>
              <span class="position-absolute topbar-badge translate-middle p-1 border border-light rounded-circle" :class="aiRobotStatus.dot">
                <span class="visually-hidden">{{ aiRobotStatus.label }}</span>
              </span>
            </button>
            <div class="dropdown-menu dropdown-menu-end p-0" style="min-width: 320px;">
              <div class="p-3 border-bottom border-bottom-dashed">
                <h6 class="m-0 fs-16 fw-semibold">AI Robot</h6>
                <small class="text-muted">{{ aiRobotStatus.label }}</small>
              </div>
              <div class="p-3">
                <div class="form-check form-switch mb-3">
                  <input class="form-check-input" type="checkbox" role="switch" id="aiRobotEnabled" v-model="aiSchedule.enabled">
                  <label class="form-check-label" for="aiRobotEnabled">Robot works on my prospects</label>
                </div>
                <div class="row g-2 mb-3">
                  <div class="col-6">
                    <label class="form-label fs-12 mb-1" for="aiRobotStart">From</label>
                    <input type="time" id="aiRobotStart" class="form-control form-control-sm" v-model="aiSchedule.start_time" :disabled="!aiSchedule.enabled">
                  </div>
                  <div class="col-6">
                    <label class="form-label fs-12 mb-1" for="aiRobotEnd">To</label>
                    <input type="time" id="aiRobotEnd" class="form-control form-control-sm" v-model="aiSchedule.end_time" :disabled="!aiSchedule.enabled">
                  </div>
                </div>
                <div class="mb-3">
                  <label class="form-label fs-12 mb-1">Days</label>
                  <div class="d-flex flex-wrap gap-1">
                    <button v-for="(label, day) in aiDays" :key="day" type="button" class="btn btn-sm"
                            :class="aiSchedule.days.includes(day) ? 'btn-primary' : 'btn-outline-secondary'"
                            :disabled="!aiSchedule.enabled" @click="toggleAiDay(day)">{{ label }}</button>
                  </div>
                </div>
                <div v-if="aiStats && aiStats.totals" class="mb-3 p-2 rounded border">
                  <div class="fs-12 fw-semibold mb-1">Last 7 days</div>
                  <div class="d-flex flex-wrap text-center fs-12">
                    <div class="px-2"><div class="fw-semibold fs-14">{{ aiStats.totals.contacted }}</div><div class="text-muted">contacted</div></div>
                    <div class="px-2"><div class="fw-semibold fs-14 text-success">{{ aiStats.totals.yes }}</div><div class="text-muted">YES</div></div>
                    <div class="px-2"><div class="fw-semibold fs-14 text-danger">{{ aiStats.totals.no }}</div><div class="text-muted">NO</div></div>
                    <div class="px-2"><div class="fw-semibold fs-14">{{ aiStats.totals.calls }}</div><div class="text-muted">calls</div></div>
                    <div class="px-2"><div class="fw-semibold fs-14 text-primary">{{ aiStats.totals.transfers }}</div><div class="text-muted">to you</div></div>
                    <div class="px-2"><div class="fw-semibold fs-14">{{ aiStats.totals.appointments }}</div><div class="text-muted">appts</div></div>
                  </div>
                </div>
                <p class="fs-12 text-muted mb-3">
                  Times are {{ aiSchedule.timezone || 'America/Chicago' }}<span v-if="aiSchedule.now_local"> (now {{ aiSchedule.now_local }})</span>.
                  Outside these hours, or with the robot off, it sends no SMS to your prospects.
                </p>
                <p class="fs-12 text-muted mb-3">
                  <i class="ri-scales-3-line"></i>
                  Legal limit: whatever hours you pick, the robot never texts outside the legal hours of each prospect's
                  state (federal 8am-9pm; Texas 9am-9pm, Sundays from noon; some states are stricter), in the prospect's local time.
                </p>
                <div class="d-flex align-items-center">
                  <button type="button" class="btn btn-sm btn-primary" :disabled="aiScheduleSaving" @click="saveAiSchedule()">
                    <span v-if="aiScheduleSaving" class="spinner-border spinner-border-sm me-1"></span>Save
                  </button>
                  <span v-if="aiScheduleMessage" class="ms-2 fs-12" :class="aiScheduleError ? 'text-danger' : 'text-success'">{{ aiScheduleMessage }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="dropdown ms-1 topbar-head-dropdown header-item">
            <button
              type="button"
              class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle position-relative"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              @click.prevent="fetchNotifications()"
            >
              <i class="bx bx-bell fs-22"></i>
              <span v-if="unreadNotificationsCount > 0" class="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">
                {{ unreadNotificationsCount }}<span class="visually-hidden">unread messages</span>
              </span>
            </button>
            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
              <div class="p-3 border-bottom border-bottom-dashed">
                  <div class="row align-items-center">
                      <div class="col">
                          <h6 class="m-0 fs-16 fw-semibold"> Notifications </h6>
                      </div>
                      <div class="col-auto">
                          <a href="javascript:void(0);" @click.prevent="markNotificationsRead('read_all')" class="badge badge-soft-primary fs-13 text-decoration-underline"> Mark all as read </a>
                      </div>
                  </div>
              </div>
              <SimpleBar data-simplebar style="max-height: 300px;">
                <div v-if="notifications.length === 0" class="p-4 text-center">
                    <h6 class="m-0 fw-normal">No notifications yet</h6>
                </div>
                <div v-for="notif in notifications" :key="notif.id"
                     class="text-reset notification-item d-block dropdown-item position-relative"
                     :class="{ 'notif-read': notif.is_read }"
                     style="cursor:pointer;"
                     @click.stop="showNotification(notif)">
                    <div class="d-flex align-items-center">
                        <!-- Unread dot -->
                        <div class="me-2">
                            <span v-if="!notif.is_read" style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#3085d6;"></span>
                            <span v-else style="display:inline-block;width:8px;height:8px;"></span>
                        </div>
                        <div class="flex-grow-1">
                            <h6 class="mt-0 mb-1 fs-13" :class="notif.is_read ? 'fw-normal text-muted' : 'fw-semibold'">{{ notif.title }}</h6>
                            <div class="fs-13 text-muted">
                                <p class="mb-1 text-truncate" style="max-width:220px;">{{ notif.message }}</p>
                            </div>
                            <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                <span><i class="mdi mdi-clock-outline"></i> {{ formatNotifDate(notif.createdOn) }}</span>
                            </p>
                        </div>
                        <div v-if="!notif.is_read" class="px-2 fs-15" @click.stop="markNotificationsRead('read_one', notif.id)">
                            <button type="button" class="btn btn-sm btn-link text-muted p-0 m-0" title="Mark as read">
                                <i class="bx bx-check-double text-success fs-20"></i>
                            </button>
                        </div>
                    </div>
                </div>
              </SimpleBar>
            </div>
          </div>
          
          <div class="dropdown ms-1 topbar-head-dropdown header-item">
            <button
              type="button"
              class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                id="header-lang-img"
                src="@/assets/images/flags/us.svg"
                alt="Header Language"
                height="20"
                class="rounded"
              />
            </button>
            <div class="dropdown-menu dropdown-menu-end">
              <!-- item--><a
                href="javascript:void(0);"
                v-for="(entry, i) in languages"
                :key="`Lang${i}`"
                :value="entry"
                @click="setLanguage(entry.language, entry.title, entry.flag)"
                :class="{ active: lan === entry.language}"
                class="dropdown-item notify-item language py-2"
                data-lang="en"
                title="English"
              >
                <img
                  :src="entry.flag"
                  alt="user-image"
                  class="me-2 rounded"
                  height="18"
                />
                <span class="align-middle">{{ entry.title }}</span>
              </a>
            </div>
          </div>

          <div class="dropdown ms-1 topbar-head-dropdown header-item">
            <button
                type="button"
                class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
              <img
                  id="header-lang-img"
                  src="@/assets/images/logo-dark.png"
                  alt="DMB"
                  data-title="eApp"
                  height="20"
                  class="rounded"
              />
            </button>
            <div class="dropdown-menu dropdown-menu-end">
              <a class="dropdown-icon-item" href="https://university.dmbgroup.online/" target="_blank">
                <img
                    src="@/assets/images/logo-dark.png"
                    alt="Agent Portal"
                />
                <span>Agent Portal</span>
              </a>
              <a class="dropdown-icon-item" href="https://www.facebook.com/DMBAGENCY" target="_blank">
                <img
                    src="@/assets/images/facebook.png"
                    alt="Facebook"
                />
                <span>DMB Facebook</span>
              </a>
              <a class="dropdown-icon-item" href="https://www.instagram.com/dmbinsuranceagency" target="_blank">
                <img
                    src="@/assets/images/instagram.png"
                    alt="Lincoln Heritage"
                />
                <span>DMB Instagram</span>
              </a>
            </div>
          </div>

          <div class="dropdown ms-1 topbar-head-dropdown header-item">
            <button
                type="button"
                class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
              <img
                  id="header-lang-img"
                  src="@/assets/images/lhlicagents_logo.png"
                  alt="LH Agents"
                  data-title="LH Agents"
                  height="20"
                  class="rounded"
              />
            </button>
            <div class="dropdown-menu dropdown-menu-end">
              <a class="dropdown-icon-item" href="https://www.lhlicagents.com/agents/" target="_blank">
                <img
                    src="@/assets/images/lhlicagents_logo.png"
                    alt="LH Agents"
                />
                <span>LH Agents</span>
              </a>
              <a class="dropdown-icon-item" href="https://www.lhlic.com/" target="_blank">
                <img
                    src="@/assets/images/lincoln_logo.jpg"
                    alt="LH Clients"
                />
                <span>LH Clients</span>
              </a>
            </div>
          </div>

          <div class="ms-1 header-item d-none d-sm-flex">
            <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle" data-toggle="fullscreen" @click="initFullScreen">
              <i class="bx bx-fullscreen fs-22"></i>
            </button>
          </div>

          <div class="ms-1 header-item d-none d-sm-flex">
            <button type="button" class=" btn btn-icon btn-topbar btn-ghost-secondary rounded-circle light-dark-mode" @click="toggleDarkMode">
              <i class="bx bx-moon fs-22"></i>
            </button>
          </div>

<!--          <div class="ms-1 header-item d-none d-sm-flex">-->
<!--            <button class=" btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"-->
<!--                    type="button"-->
<!--                    data-bs-toggle="offcanvas"-->
<!--                    data-bs-target="#phoneFunction"-->
<!--                    aria-controls="phoneFunction">-->
<!--              <i class="bx bx-phone fs-22"></i>-->
<!--            </button>-->
<!--          </div>-->

<!--         <div class="dropdown topbar-head-dropdown ms-1 header-item">-->
<!--            <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle" id="page-header-notifications-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
<!--              <i class="bx bx-bell fs-22"></i>-->
<!--              <span class="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">-->
<!--                0<span class="visually-hidden">unread messages</span></span>-->
<!--            </button>-->
<!--            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" aria-labelledby="page-header-notifications-dropdown">-->
<!--              <div class="dropdown-head bg-primary bg-pattern rounded-top">-->
<!--                <div class="p-3">-->
<!--                  <div class="row align-items-center">-->
<!--                    <div class="col">-->
<!--                      <h6 class="m-0 fs-16 fw-semibold text-white">-->
<!--                        Notifications-->
<!--                      </h6>-->
<!--                    </div>-->
<!--                    <div class="col-auto dropdown-tabs">-->
<!--                      <span class="badge badge-soft-light fs-13"> 0 New</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--&lt;!&ndash;                <div class="px-2 pt-2">&ndash;&gt;-->
<!--&lt;!&ndash;                  <ul class="nav nav-tabs dropdown-tabs nav-tabs-custom" data-dropdown-tabs="true" id="notificationItemsTab" role="tablist">&ndash;&gt;-->
<!--&lt;!&ndash;                    <li class="nav-item">&ndash;&gt;-->
<!--&lt;!&ndash;                      <a class="nav-link active" data-bs-toggle="tab" href="#all-noti-tab" role="tab" aria-selected="false" @click.capture.stop>&ndash;&gt;-->
<!--&lt;!&ndash;                        All (4)&ndash;&gt;-->
<!--&lt;!&ndash;                      </a>&ndash;&gt;-->
<!--&lt;!&ndash;                    </li>&ndash;&gt;-->
<!--&lt;!&ndash;                    <li class="nav-item">&ndash;&gt;-->
<!--&lt;!&ndash;                      <a class="nav-link" data-bs-toggle="tab" href="#messages-tab" role="tab" aria-selected="true" @click.capture.stop>&ndash;&gt;-->
<!--&lt;!&ndash;                        Messages&ndash;&gt;-->
<!--&lt;!&ndash;                      </a>&ndash;&gt;-->
<!--&lt;!&ndash;                    </li>&ndash;&gt;-->
<!--&lt;!&ndash;                    <li class="nav-item">&ndash;&gt;-->
<!--&lt;!&ndash;                      <a class="nav-link" data-bs-toggle="tab" href="#alerts-tab" role="tab" aria-selected="false" @click.capture.stop>&ndash;&gt;-->
<!--&lt;!&ndash;                        Alerts&ndash;&gt;-->
<!--&lt;!&ndash;                      </a>&ndash;&gt;-->
<!--&lt;!&ndash;                    </li>&ndash;&gt;-->
<!--&lt;!&ndash;                  </ul>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--              </div>-->

<!--              <div class="tab-content" id="notificationItemsTabContent">-->

<!--&lt;!&ndash;                <div class="tab-pane fade py-2 ps-2 show active" id="all-noti-tab" role="tabpanel">&ndash;&gt;-->
<!--&lt;!&ndash;                  <SimpleBar data-simplebar style="max-height: 300px" class="pe-2">&ndash;&gt;-->
<!--&lt;!&ndash;                    <div class="text-reset notification-item d-block dropdown-item position-relative">&ndash;&gt;-->
<!--&lt;!&ndash;                      <div class="d-flex">&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="avatar-xs me-3">&ndash;&gt;-->
<!--&lt;!&ndash;                          <span class="avatar-title bg-soft-info text-info rounded-circle fs-16">&ndash;&gt;-->
<!--&lt;!&ndash;                            <i class="bx bx-badge-check"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                          </span>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="flex-1">&ndash;&gt;-->
<!--&lt;!&ndash;                          <a href="#!" class="stretched-link">&ndash;&gt;-->
<!--&lt;!&ndash;                            <h6 class="mt-0 mb-2 lh-base">&ndash;&gt;-->
<!--&lt;!&ndash;                              Your <b>Elite</b> author Graphic Optimization&ndash;&gt;-->
<!--&lt;!&ndash;                              <span class="text-secondary">reward</span> is&ndash;&gt;-->
<!--&lt;!&ndash;                              ready!&ndash;&gt;-->
<!--&lt;!&ndash;                            </h6>&ndash;&gt;-->
<!--&lt;!&ndash;                          </a>&ndash;&gt;-->
<!--&lt;!&ndash;                          <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">&ndash;&gt;-->
<!--&lt;!&ndash;                            <span><i class="mdi mdi-clock-outline"></i> Just 30 sec ago</span>&ndash;&gt;-->
<!--&lt;!&ndash;                          </p>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="px-2 fs-15">&ndash;&gt;-->
<!--&lt;!&ndash;                          <input class="form-check-input" type="checkbox" />&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->

<!--&lt;!&ndash;                    <div class="text-reset notification-item d-block dropdown-item position-relative">&ndash;&gt;-->
<!--&lt;!&ndash;                      <div class="d-flex">&ndash;&gt;-->
<!--&lt;!&ndash;                        <img src="@/assets/images/users/avatar-2.jpg" class="me-3 rounded-circle avatar-xs" alt="user-pic" />&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="flex-1">&ndash;&gt;-->
<!--&lt;!&ndash;                          <a href="#!" class="stretched-link">&ndash;&gt;-->
<!--&lt;!&ndash;                            <h6 class="mt-0 mb-1 fs-13 fw-semibold">&ndash;&gt;-->
<!--&lt;!&ndash;                              Angela Bernier&ndash;&gt;-->
<!--&lt;!&ndash;                            </h6></a>&ndash;&gt;-->
<!--&lt;!&ndash;                          <div class="fs-13 text-muted">&ndash;&gt;-->
<!--&lt;!&ndash;                            <p class="mb-1">&ndash;&gt;-->
<!--&lt;!&ndash;                              Answered to your comment on the cash flow forecast's graph 🔔.&ndash;&gt;-->
<!--&lt;!&ndash;                            </p>&ndash;&gt;-->
<!--&lt;!&ndash;                          </div>&ndash;&gt;-->
<!--&lt;!&ndash;                          <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">&ndash;&gt;-->
<!--&lt;!&ndash;                            <span><i class="mdi mdi-clock-outline"></i> 48 min ago</span>&ndash;&gt;-->
<!--&lt;!&ndash;                          </p>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="px-2 fs-15">&ndash;&gt;-->
<!--&lt;!&ndash;                          <input class="form-check-input" type="checkbox" />&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->

<!--&lt;!&ndash;                    <div class="text-reset notification-item d-block dropdown-item position-relative">&ndash;&gt;-->
<!--&lt;!&ndash;                      <div class="d-flex">&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="avatar-xs me-3">&ndash;&gt;-->
<!--&lt;!&ndash;                          <span&ndash;&gt;-->
<!--&lt;!&ndash;                            class="avatar-title bg-soft-danger text-danger rounded-circle fs-16"&ndash;&gt;-->
<!--&lt;!&ndash;                          >&ndash;&gt;-->
<!--&lt;!&ndash;                            <i class="bx bx-message-square-dots"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                          </span>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="flex-1">&ndash;&gt;-->
<!--&lt;!&ndash;                          <a href="#!" class="stretched-link">&ndash;&gt;-->
<!--&lt;!&ndash;                            <h6 class="mt-0 mb-2 fs-13 lh-base">&ndash;&gt;-->
<!--&lt;!&ndash;                              You have received <b class="text-success">20</b> new messages in the conversation&ndash;&gt;-->
<!--&lt;!&ndash;                            </h6>&ndash;&gt;-->
<!--&lt;!&ndash;                          </a>&ndash;&gt;-->
<!--&lt;!&ndash;                          <p&ndash;&gt;-->
<!--&lt;!&ndash;                            class="mb-0 fs-11 fw-medium text-uppercase text-muted"&ndash;&gt;-->
<!--&lt;!&ndash;                          >&ndash;&gt;-->
<!--&lt;!&ndash;                            <span&ndash;&gt;-->
<!--&lt;!&ndash;                              ><i class="mdi mdi-clock-outline"></i> 2 hrs&ndash;&gt;-->
<!--&lt;!&ndash;                              ago</span&ndash;&gt;-->
<!--&lt;!&ndash;                            >&ndash;&gt;-->
<!--&lt;!&ndash;                          </p>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="px-2 fs-15">&ndash;&gt;-->
<!--&lt;!&ndash;                          <input class="form-check-input" type="checkbox" />&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->

<!--&lt;!&ndash;                    <div&ndash;&gt;-->
<!--&lt;!&ndash;                      class="text-reset notification-item d-block dropdown-item position-relative"&ndash;&gt;-->
<!--&lt;!&ndash;                    >&ndash;&gt;-->
<!--&lt;!&ndash;                      <div class="d-flex">&ndash;&gt;-->
<!--&lt;!&ndash;                        <img&ndash;&gt;-->
<!--&lt;!&ndash;                          src="@/assets/images/users/avatar-8.jpg"&ndash;&gt;-->
<!--&lt;!&ndash;                          class="me-3 rounded-circle avatar-xs"&ndash;&gt;-->
<!--&lt;!&ndash;                          alt="user-pic"&ndash;&gt;-->
<!--&lt;!&ndash;                        />&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="flex-1">&ndash;&gt;-->
<!--&lt;!&ndash;                          <a href="#!" class="stretched-link"&ndash;&gt;-->
<!--&lt;!&ndash;                            ><h6 class="mt-0 mb-1 fs-13 fw-semibold">&ndash;&gt;-->
<!--&lt;!&ndash;                              Maureen Gibson&ndash;&gt;-->
<!--&lt;!&ndash;                            </h6></a&ndash;&gt;-->
<!--&lt;!&ndash;                          >&ndash;&gt;-->
<!--&lt;!&ndash;                          <div class="fs-13 text-muted">&ndash;&gt;-->
<!--&lt;!&ndash;                            <p class="mb-1">&ndash;&gt;-->
<!--&lt;!&ndash;                              We talked about a project on linkedin.&ndash;&gt;-->
<!--&lt;!&ndash;                            </p>&ndash;&gt;-->
<!--&lt;!&ndash;                          </div>&ndash;&gt;-->
<!--&lt;!&ndash;                          <p&ndash;&gt;-->
<!--&lt;!&ndash;                            class="mb-0 fs-11 fw-medium text-uppercase text-muted"&ndash;&gt;-->
<!--&lt;!&ndash;                          >&ndash;&gt;-->
<!--&lt;!&ndash;                            <span&ndash;&gt;-->
<!--&lt;!&ndash;                              ><i class="mdi mdi-clock-outline"></i> 4 hrs&ndash;&gt;-->
<!--&lt;!&ndash;                              ago</span&ndash;&gt;-->
<!--&lt;!&ndash;                            >&ndash;&gt;-->
<!--&lt;!&ndash;                          </p>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="px-2 fs-15">&ndash;&gt;-->
<!--&lt;!&ndash;                          <input class="form-check-input" type="checkbox" />&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->

<!--&lt;!&ndash;                    <div class="my-3 text-center">&ndash;&gt;-->
<!--&lt;!&ndash;                      <button type="button" class="btn btn-soft-success">&ndash;&gt;-->
<!--&lt;!&ndash;                        View All Notifications&ndash;&gt;-->
<!--&lt;!&ndash;                        <i class="ri-arrow-right-line align-middle"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                      </button>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                  </SimpleBar>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->

<!--&lt;!&ndash;                <div class="tab-pane fade py-2 ps-2" id="messages-tab" role="tabpanel" aria-labelledby="messages-tab">&ndash;&gt;-->
<!--&lt;!&ndash;                  <SimpleBar data-simplebar style="max-height: 300px" class="pe-2">&ndash;&gt;-->
<!--&lt;!&ndash;                    <div class="text-reset notification-item d-block dropdown-item">&ndash;&gt;-->
<!--&lt;!&ndash;                      <div class="d-flex">&ndash;&gt;-->
<!--&lt;!&ndash;                        <img src="@/assets/images/users/avatar-3.jpg" class="me-3 rounded-circle avatar-xs" alt="user-pic" />&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="flex-1">&ndash;&gt;-->
<!--&lt;!&ndash;                          <a href="#!" class="stretched-link">&ndash;&gt;-->
<!--&lt;!&ndash;                            <h6 class="mt-0 mb-1 fs-13 fw-semibold">&ndash;&gt;-->
<!--&lt;!&ndash;                              James Lemire&ndash;&gt;-->
<!--&lt;!&ndash;                            </h6></a>&ndash;&gt;-->
<!--&lt;!&ndash;                          <div class="fs-13 text-muted">&ndash;&gt;-->
<!--&lt;!&ndash;                            <p class="mb-1">&ndash;&gt;-->
<!--&lt;!&ndash;                              We talked about a project on linkedin.&ndash;&gt;-->
<!--&lt;!&ndash;                            </p>&ndash;&gt;-->
<!--&lt;!&ndash;                          </div>&ndash;&gt;-->
<!--&lt;!&ndash;                          <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">&ndash;&gt;-->
<!--&lt;!&ndash;                            <span><i class="mdi mdi-clock-outline"></i> 30 min ago</span>&ndash;&gt;-->
<!--&lt;!&ndash;                          </p>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="px-2 fs-15">&ndash;&gt;-->
<!--&lt;!&ndash;                          <input class="form-check-input" type="checkbox" />&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->

<!--&lt;!&ndash;                    <div class="text-reset notification-item d-block dropdown-item">&ndash;&gt;-->
<!--&lt;!&ndash;                      <div class="d-flex">&ndash;&gt;-->
<!--&lt;!&ndash;                        <img src="@/assets/images/users/avatar-2.jpg" class="me-3 rounded-circle avatar-xs" alt="user-pic" />&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="flex-1">&ndash;&gt;-->
<!--&lt;!&ndash;                          <a href="#!" class="stretched-link">&ndash;&gt;-->
<!--&lt;!&ndash;                            <h6 class="mt-0 mb-1 fs-13 fw-semibold">&ndash;&gt;-->
<!--&lt;!&ndash;                              Angela Bernier&ndash;&gt;-->
<!--&lt;!&ndash;                            </h6></a>&ndash;&gt;-->
<!--&lt;!&ndash;                          <div class="fs-13 text-muted">&ndash;&gt;-->
<!--&lt;!&ndash;                            <p class="mb-1">&ndash;&gt;-->
<!--&lt;!&ndash;                              Answered to your comment on the cash flow&ndash;&gt;-->
<!--&lt;!&ndash;                              forecast's graph 🔔.&ndash;&gt;-->
<!--&lt;!&ndash;                            </p>&ndash;&gt;-->
<!--&lt;!&ndash;                          </div>&ndash;&gt;-->
<!--&lt;!&ndash;                          <p&ndash;&gt;-->
<!--&lt;!&ndash;                            class="mb-0 fs-11 fw-medium text-uppercase text-muted"&ndash;&gt;-->
<!--&lt;!&ndash;                          >&ndash;&gt;-->
<!--&lt;!&ndash;                            <span&ndash;&gt;-->
<!--&lt;!&ndash;                              ><i class="mdi mdi-clock-outline"></i> 2 hrs&ndash;&gt;-->
<!--&lt;!&ndash;                              ago</span&ndash;&gt;-->
<!--&lt;!&ndash;                            >&ndash;&gt;-->
<!--&lt;!&ndash;                          </p>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="px-2 fs-15">&ndash;&gt;-->
<!--&lt;!&ndash;                          <input class="form-check-input" type="checkbox" />&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->

<!--&lt;!&ndash;                    <div&ndash;&gt;-->
<!--&lt;!&ndash;                      class="text-reset notification-item d-block dropdown-item"&ndash;&gt;-->
<!--&lt;!&ndash;                    >&ndash;&gt;-->
<!--&lt;!&ndash;                      <div class="d-flex">&ndash;&gt;-->
<!--&lt;!&ndash;                        <img&ndash;&gt;-->
<!--&lt;!&ndash;                          src="@/assets/images/users/avatar-6.jpg"&ndash;&gt;-->
<!--&lt;!&ndash;                          class="me-3 rounded-circle avatar-xs"&ndash;&gt;-->
<!--&lt;!&ndash;                          alt="user-pic"&ndash;&gt;-->
<!--&lt;!&ndash;                        />&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="flex-1">&ndash;&gt;-->
<!--&lt;!&ndash;                          <a href="#!" class="stretched-link"&ndash;&gt;-->
<!--&lt;!&ndash;                            ><h6 class="mt-0 mb-1 fs-13 fw-semibold">&ndash;&gt;-->
<!--&lt;!&ndash;                              Kenneth Brown&ndash;&gt;-->
<!--&lt;!&ndash;                            </h6></a&ndash;&gt;-->
<!--&lt;!&ndash;                          >&ndash;&gt;-->
<!--&lt;!&ndash;                          <div class="fs-13 text-muted">&ndash;&gt;-->
<!--&lt;!&ndash;                            <p class="mb-1">&ndash;&gt;-->
<!--&lt;!&ndash;                              Mentionned you in his comment on 📃 invoice&ndash;&gt;-->
<!--&lt;!&ndash;                              #12501.&ndash;&gt;-->
<!--&lt;!&ndash;                            </p>&ndash;&gt;-->
<!--&lt;!&ndash;                          </div>&ndash;&gt;-->
<!--&lt;!&ndash;                          <p&ndash;&gt;-->
<!--&lt;!&ndash;                            class="mb-0 fs-11 fw-medium text-uppercase text-muted"&ndash;&gt;-->
<!--&lt;!&ndash;                          >&ndash;&gt;-->
<!--&lt;!&ndash;                            <span&ndash;&gt;-->
<!--&lt;!&ndash;                              ><i class="mdi mdi-clock-outline"></i> 10 hrs&ndash;&gt;-->
<!--&lt;!&ndash;                              ago</span&ndash;&gt;-->
<!--&lt;!&ndash;                            >&ndash;&gt;-->
<!--&lt;!&ndash;                          </p>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="px-2 fs-15">&ndash;&gt;-->
<!--&lt;!&ndash;                          <input class="form-check-input" type="checkbox" />&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->

<!--&lt;!&ndash;                    <div&ndash;&gt;-->
<!--&lt;!&ndash;                      class="text-reset notification-item d-block dropdown-item"&ndash;&gt;-->
<!--&lt;!&ndash;                    >&ndash;&gt;-->
<!--&lt;!&ndash;                      <div class="d-flex">&ndash;&gt;-->
<!--&lt;!&ndash;                        <img&ndash;&gt;-->
<!--&lt;!&ndash;                          src="@/assets/images/users/avatar-8.jpg"&ndash;&gt;-->
<!--&lt;!&ndash;                          class="me-3 rounded-circle avatar-xs"&ndash;&gt;-->
<!--&lt;!&ndash;                          alt="user-pic"&ndash;&gt;-->
<!--&lt;!&ndash;                        />&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="flex-1">&ndash;&gt;-->
<!--&lt;!&ndash;                          <a href="#!" class="stretched-link"&ndash;&gt;-->
<!--&lt;!&ndash;                            ><h6 class="mt-0 mb-1 fs-13 fw-semibold">&ndash;&gt;-->
<!--&lt;!&ndash;                              Maureen Gibson&ndash;&gt;-->
<!--&lt;!&ndash;                            </h6></a&ndash;&gt;-->
<!--&lt;!&ndash;                          >&ndash;&gt;-->
<!--&lt;!&ndash;                          <div class="fs-13 text-muted">&ndash;&gt;-->
<!--&lt;!&ndash;                            <p class="mb-1">&ndash;&gt;-->
<!--&lt;!&ndash;                              We talked about a project on linkedin.&ndash;&gt;-->
<!--&lt;!&ndash;                            </p>&ndash;&gt;-->
<!--&lt;!&ndash;                          </div>&ndash;&gt;-->
<!--&lt;!&ndash;                          <p&ndash;&gt;-->
<!--&lt;!&ndash;                            class="mb-0 fs-11 fw-medium text-uppercase text-muted"&ndash;&gt;-->
<!--&lt;!&ndash;                          >&ndash;&gt;-->
<!--&lt;!&ndash;                            <span&ndash;&gt;-->
<!--&lt;!&ndash;                              ><i class="mdi mdi-clock-outline"></i> 3 days&ndash;&gt;-->
<!--&lt;!&ndash;                              ago</span&ndash;&gt;-->
<!--&lt;!&ndash;                            >&ndash;&gt;-->
<!--&lt;!&ndash;                          </p>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="px-2 fs-15">&ndash;&gt;-->
<!--&lt;!&ndash;                          <input class="form-check-input" type="checkbox" />&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->

<!--&lt;!&ndash;                    <div class="my-3 text-center">&ndash;&gt;-->
<!--&lt;!&ndash;                      <button type="button" class="btn btn-soft-success">&ndash;&gt;-->
<!--&lt;!&ndash;                        View All Messages&ndash;&gt;-->
<!--&lt;!&ndash;                        <i class="ri-arrow-right-line align-middle"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                      </button>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                  </SimpleBar>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->

<!--&lt;!&ndash;                <div class="tab-pane fade p-4" id="alerts-tab" role="tabpanel" aria-labelledby="alerts-tab">&ndash;&gt;-->
<!--&lt;!&ndash;                  <div class="w-25 w-sm-50 pt-3 mx-auto">&ndash;&gt;-->
<!--&lt;!&ndash;                    <img src="@/assets/images/svg/bell.svg" class="img-fluid" alt="user-pic"/>&ndash;&gt;-->
<!--&lt;!&ndash;                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                  <div class="text-center pb-5 mt-2">&ndash;&gt;-->
<!--&lt;!&ndash;                    <h6 class="fs-18 fw-semibold lh-base">&ndash;&gt;-->
<!--&lt;!&ndash;                      Hey! You have no any notifications&ndash;&gt;-->
<!--&lt;!&ndash;                    </h6>&ndash;&gt;-->
<!--&lt;!&ndash;                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->

<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

          <div class="dropdown ms-sm-3 header-item topbar-user">
            <button type="button" class="btn" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span class="d-flex align-items-center">
                <img class="rounded-circle header-profile-user " style="object-fit: cover;" v-bind:src="profile" />
                <span class="text-start ms-xl-2">
                  <span class=" d-none d-xl-inline-block ms-1 fw-medium user-name-text">{{userFullName}}</span>
<!--                  <span class="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">Super Admin</span>-->
                </span>
              </span>
            </button>
            <div class="dropdown-menu dropdown-menu-end">
              <!-- item-->
              <h6 class="dropdown-header">Welcome {{userFirstName}}!</h6>
              <router-link class="dropdown-item" to="/profile">
                <i class="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                <span class="align-middle">Profile</span>
              </router-link>
              <div class="dropdown-divider"></div>
              <router-link class="dropdown-item" to="/pages/profile-setting"
                ><span class="badge bg-soft-success text-success mt-1 float-end"
                  >New</span
                ><i
                  class="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"
                ></i>
                <span class="align-middle">Settings</span></router-link
              >
<!--              <router-link class="dropdown-item" to="/auth/lockscreen-basic"-->
<!--                ><i class="mdi mdi-lock text-muted fs-16 align-middle me-1"></i>-->
<!--                <span class="align-middle">Lock screen</span></router-link-->
<!--              >-->
              <a class="dropdown-item" href="/logout" @click="logout()">
                <i class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
                <span class="align-middle" data-key="t-logout">Logout</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>

    <!-- Meta Messenger Offcanvas Sidebar -->
    <div class="offcanvas offcanvas-end shadow-lg" data-bs-backdrop="false" data-bs-scroll="true" tabindex="-1" id="metaMessengerSidebar" aria-labelledby="metaMessengerSidebarLabel" style="width: 360px; background-color: #242526; color: #E4E6EB; border-left: 1px solid #3E4042; top: 70px;">
        <div class="offcanvas-header pb-0 d-flex flex-column align-items-stretch border-0">
            <!-- Header -->
            <div class="d-flex align-items-center justify-content-between mb-3 w-100 mt-2">
                <h5 class="m-0 fw-bold" style="color: #E4E6EB; font-size: 24px;" id="metaMessengerSidebarLabel"> Chats </h5>
                <div class="d-flex gap-2">
                    <div class="rounded-circle d-flex align-items-center justify-content-center cursor-pointer" style="width: 36px; height: 36px; background-color: #3A3B3C; transition: 0.2s;" onmouseover="this.style.backgroundColor='#4E4F50'" onmouseout="this.style.backgroundColor='#3A3B3C'">
                        <i class="bx bx-dots-horizontal-rounded fs-20" style="color: #E4E6EB;"></i>
                    </div>
                    <div class="rounded-circle d-flex align-items-center justify-content-center cursor-pointer" style="width: 36px; height: 36px; background-color: #3A3B3C; transition: 0.2s;" onmouseover="this.style.backgroundColor='#4E4F50'" onmouseout="this.style.backgroundColor='#3A3B3C'">
                        <i class="bx bx-expand-alt fs-18" style="color: #E4E6EB;"></i>
                    </div>
                    <div class="rounded-circle d-flex align-items-center justify-content-center cursor-pointer" style="width: 36px; height: 36px; background-color: #3A3B3C; transition: 0.2s;" onmouseover="this.style.backgroundColor='#4E4F50'" onmouseout="this.style.backgroundColor='#3A3B3C'">
                        <i class="bx bx-edit fs-18" style="color: #E4E6EB;"></i>
                    </div>
                </div>
            </div>
            
            <!-- Search Bar -->
            <div class="position-relative mb-3">
                <input type="text" class="form-control rounded-pill border-0 ps-5 shadow-none" placeholder="Search Messenger" style="font-size: 15px; padding: 10px 16px; background-color: #3A3B3C; color: #E4E6EB;">
                <i class="bx bx-search position-absolute top-50 start-0 translate-middle-y ms-3 fs-20" style="color: #B0B3B8;"></i>
            </div>
            
            <!-- Tabs -->
            <div class="d-flex gap-2 mb-2">
                <span class="badge rounded-pill px-3 py-2 fs-14 cursor-pointer fw-semibold" style="background-color: rgba(45, 136, 255, 0.15); color: #2D88FF;">All</span>
                <span class="badge rounded-pill px-3 py-2 fs-14 cursor-pointer fw-semibold" style="background-color: #3A3B3C; color: #E4E6EB; transition: 0.2s;" onmouseover="this.style.backgroundColor='#4E4F50'" onmouseout="this.style.backgroundColor='#3A3B3C'">Unread</span>
                <span class="badge rounded-pill px-3 py-2 fs-14 cursor-pointer fw-semibold" style="background-color: #3A3B3C; color: #E4E6EB; transition: 0.2s;" onmouseover="this.style.backgroundColor='#4E4F50'" onmouseout="this.style.backgroundColor='#3A3B3C'">Groups</span>
                <span class="badge rounded-pill px-3 py-2 fs-14 cursor-pointer fw-semibold" style="background-color: #3A3B3C; color: #E4E6EB; transition: 0.2s;" onmouseover="this.style.backgroundColor='#4E4F50'" onmouseout="this.style.backgroundColor='#3A3B3C'">Communities</span>
            </div>
        </div>
        
        <div class="offcanvas-body p-0 d-flex flex-column">
            <SimpleBar data-simplebar class="flex-grow-1 h-100">
            <div class="p-2">
                <a href="javascript:void(0);" 
                    class="d-block rounded-3 mb-1 p-2 text-decoration-none" 
                    v-for="conv in metaConversations" 
                    :key="conv.contact_id"
                    @click.prevent="openMetaChat(conv)"
                    data-bs-dismiss="offcanvas"
                    style="transition: background-color 0.2s;"
                    onmouseover="this.style.backgroundColor='#3A3B3C'"
                    onmouseout="this.style.backgroundColor='transparent'">
                    
                    <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 me-3 position-relative">
                            <!-- Large Avatar -->
                            <img :src="conv.contact_picture || require('@/assets/images/users/user-dummy-img.jpg')" class="rounded-circle" style="width: 56px; height: 56px; object-fit: cover;" alt="user">
                        </div>
                        
                        <div class="flex-grow-1 overflow-hidden">
                            <!-- Name -->
                            <h6 class="mb-1 text-truncate fs-15 d-flex align-items-center" :class="conv.is_unread ? 'fw-bold' : 'fw-semibold'" :style="{color: conv.is_unread ? '#E4E6EB' : '#E4E6EB'}">
                                <i :class="conv.platform === 'instagram' ? 'bx bxl-instagram text-danger me-1' : 'bx bxl-messenger text-primary me-1'"></i>
                                {{ conv.contact_name }}
                            </h6>
                            
                            <!-- Message Snippet -->
                            <div class="d-flex align-items-center fs-13">
                                <span class="text-truncate me-1" :class="conv.is_unread ? 'fw-bold' : ''" :style="{color: conv.is_unread ? '#E4E6EB' : '#B0B3B8', maxWidth: '180px'}">
                                    {{ conv.latest_message }}
                                </span>
                                <span :class="conv.is_unread ? 'fw-bold' : ''" :style="{color: conv.is_unread ? '#E4E6EB' : '#B0B3B8'}"> · {{ formatTimeAgo(conv.timestamp) }}</span>
                            </div>
                        </div>
                        
                        <!-- Unread Indicator -->
                        <div class="flex-shrink-0 ms-2" v-if="conv.is_unread">
                            <div class="rounded-circle" style="width: 12px; height: 12px; background-color: #2D88FF;"></div>
                        </div>
                    </div>
                </a>
                
                <div class="text-center pb-4 pt-5" v-if="metaConversations.length === 0">
                    <div class="d-inline-flex align-items-center justify-content-center rounded-circle mb-3" style="width: 80px; height: 80px; background-color: #3A3B3C;">
                        <i class="bx bxl-messenger" style="font-size: 40px; color: #E4E6EB;"></i>
                    </div>
                    <h6 class="fs-15 fw-normal m-0" style="color: #E4E6EB;">No recent messages</h6>
                </div>
            </div>
            </SimpleBar>
            
            <!-- Footer -->
            <div class="p-3 text-center mt-auto" style="border-top: 1px solid #3E4042;">
                <a href="javascript:void(0);" class="fw-semibold fs-15 text-decoration-none" style="color: #2D88FF;">See all in Messenger</a>
            </div>
        </div>
    </div>

  <!-- right offcanvas -->
  <div class="offcanvas offcanvas-end" tabindex="-1" id="phoneFunction" aria-labelledby="offcanvasRightLabel">
    <div class="offcanvas-header">
      <h5 id="offcanvasRightLabel">Offcanvas Right</h5>
      <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
    </div>
  </div>

  <!-- Bootcamp -->
  <BModal id="bootcampModal" hide-footer class="v-modal-custom" hide-header-close centered>
    <div class="modal-body text-center">

      <div colors="primary:#25a0e2,secondary:#00bd9d" trigger="loop"
           style="width: 120px; height: 120px; overflow: hidden; margin: 0px auto;">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 500 500"
             width="500" height="500" preserveAspectRatio="xMidYMid meet"
             style="width: 100%; height: 100%; transform: translate3d(0px, 0px, 0px); content-visibility: visible;">
          <defs>
            <clipPath id="__lottie_element_136">
              <rect width="500" height="500" x="0" y="0"></rect>
            </clipPath>
            <g id="__lottie_element_146">
              <g transform="matrix(4.5,0,0,4.5,250.06300354003906,270.9770202636719)" opacity="1"
                 style="display: block;">
                <g opacity="1" transform="matrix(-1,0,0,1,0,0)">
                  <path fill="rgb(18,19,49)" fill-opacity="1"
                        d=" M-7.894623279571533,-0.7708492279052734 C-7.894623279571533,-0.7708492279052734 -22.89600944519043,-0.419234037399292 -22.89600944519043,-0.419234037399292 C-22.89600944519043,-0.419234037399292 -21.806299209594727,1.5694150924682617 -21.806299209594727,1.5694150924682617 C-21.806299209594727,1.5694150924682617 -8.55629825592041,4.694415092468262 -8.55629825592041,4.694415092468262 C-8.55629825592041,4.694415092468262 -7.894623279571533,-0.7708492279052734 -7.894623279571533,-0.7708492279052734z"></path>
                </g>
                <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                  <path fill="rgb(18,19,49)" fill-opacity="1"
                        d=" M-7.894623279571533,-0.7708492279052734 C-7.894623279571533,-0.7708492279052734 -22.89600944519043,-0.419234037399292 -22.89600944519043,-0.419234037399292 C-22.89600944519043,-0.419234037399292 -21.806299209594727,1.5694150924682617 -21.806299209594727,1.5694150924682617 C-21.806299209594727,1.5694150924682617 -8.55629825592041,4.694415092468262 -8.55629825592041,4.694415092468262 C-8.55629825592041,4.694415092468262 -7.894623279571533,-0.7708492279052734 -7.894623279571533,-0.7708492279052734z"></path>
                </g>
              </g>
            </g>
            <filter id="__lottie_element_158" filterUnits="objectBoundingBox" x="0%" y="0%" width="100%"
                    height="100%">
              <feComponentTransfer in="SourceGraphic">
                <feFuncA type="table" tableValues="1.0 0.0"></feFuncA>
              </feComponentTransfer>
            </filter>
            <mask id="__lottie_element_146_2" mask-type="alpha">
              <g filter="url(#__lottie_element_158)">
                <rect width="500" height="500" x="0" y="0" fill="#ffffff" opacity="0"></rect>
                <use xlink:href="#__lottie_element_146"></use>
              </g>
            </mask>
          </defs>
          <g clip-path="url(#__lottie_element_136)">
            <g transform="matrix(4.5,0,0,4.5,250.75149536132812,251.125)" opacity="1" style="display: block;">
              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                <path stroke-linecap="round" stroke-linejoin="round" fill-opacity="0" stroke="rgb(18,19,49)"
                      stroke-opacity="1" stroke-width="2.8000000000000003"
                      d=" M40.75,0 C40.75,22.690000534057617 22.35700035095215,41.08300018310547 -0.3330000042915344,41.08300018310547 C-23.023000717163086,41.08300018310547 -41.41699981689453,22.690000534057617 -41.41699981689453,0 C-41.41699981689453,-22.690000534057617 -23.023000717163086,-41.08300018310547 -0.3330000042915344,-41.08300018310547 C22.35700035095215,-41.08300018310547 40.75,-22.690000534057617 40.75,0z"></path>
              </g>
            </g>
            <g transform="matrix(4.500003814697266,0,0,4.500003814697266,250.7519989013672,169.48443603515625)"
               opacity="1" style="display: block;">
              <g opacity="1" transform="matrix(1,0,0,1,-0.125,21.625)">
                <path stroke-linecap="round" stroke-linejoin="round" fill-opacity="0" stroke="rgb(18,19,49)"
                      stroke-opacity="1" stroke-width="2.8000000000000003"
                      d=" M12.267999649047852,16.886999130249023 C8.822999954223633,19.395000457763672 4.583000183105469,20.875 0,20.875 C-4.583000183105469,20.875 -8.822999954223633,19.395000457763672 -12.267999649047852,16.886999130249023"></path>
              </g>
            </g>
            <g mask="url(#__lottie_element_146_2)" style="display: block;">
              <g transform="matrix(4.5,0,0,4.5,250.75149536132812,267.3590087890625)" opacity="1">
                <g opacity="1" transform="matrix(-1,0,0,1,0,0)">
                  <g opacity="1" transform="matrix(1,0,0,1,-15.187999725341797,-9.812000274658203)">
                    <path fill="rgb(18,19,49)" fill-opacity="1"
                          d=" M0,-4 C2.2076001167297363,-4 4,-2.2076001167297363 4,0 C4,2.2076001167297363 2.2076001167297363,4 0,4 C-2.2076001167297363,4 -4,2.2076001167297363 -4,0 C-4,-2.2076001167297363 -2.2076001167297363,-4 0,-4z"></path>
                  </g>
                  <path stroke-linecap="round" stroke-linejoin="round" fill-opacity="0" stroke="rgb(8,168,138)"
                        stroke-opacity="1" stroke-width="2.8000000000000003"
                        d=" M-11.25,-23.625 C-11.25,-23.625 -18.25,-24.625 -23.75,-18.875"></path>
                  <g opacity="1" transform="matrix(1,0,0,1,0,0)"></g>
                </g>
                <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                  <g opacity="1" transform="matrix(1,0,0,1,-15.187999725341797,-9.812000274658203)">
                    <path fill="rgb(18,19,49)" fill-opacity="1"
                          d=" M0,-4 C2.2076001167297363,-4 4,-2.2076001167297363 4,0 C4,2.2076001167297363 2.2076001167297363,4 0,4 C-2.2076001167297363,4 -4,2.2076001167297363 -4,0 C-4,-2.2076001167297363 -2.2076001167297363,-4 0,-4z"></path>
                  </g>
                  <path stroke-linecap="round" stroke-linejoin="round" fill-opacity="0" stroke="rgb(8,168,138)"
                        stroke-opacity="1" stroke-width="2.8000000000000003"
                        d=" M-11.25,-23.625 C-11.25,-23.625 -18.25,-24.625 -23.75,-18.875"></path>
                  <g opacity="1" transform="matrix(1,0,0,1,0,0)"></g>
                </g>
              </g>
            </g>
            <g class="com" style="display: none;">
              <g>
                <path></path>
              </g>
              <g>
                <path></path>
              </g>
              <g>
                <path></path>
              </g>
              <g>
                <path></path>
              </g>
              <g>
                <path></path>
              </g>
              <g>
                <path></path>
              </g>
              <g>
                <path></path>
              </g>
              <g>
                <path></path>
              </g>
              <g>
                <path></path>
              </g>
              <g>
                <path></path>
              </g>
              <g>
                <path></path>
              </g>
              <g>
                <path></path>
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div class="mt-4" @click="getBootcampInfo"><h4 class="mb-3" >Keep your bootcamp Assistance Updated!</h4></div>

      <td v-for="(n, i) of this.assist" :key="i">
        <div class="form-check form-switch-md form-check-inline" dir="ltr">
            <span  v-for="(x, y) of n.assistance" :key="y">
<!--              <label class="form-check-label" :for="'inlineswitch'+parseInt(y)+1">&nbsp;{{ parseInt(y)+1}}&nbsp;</label>-->
              <div class="form-check form-switch">
                <label class="form-check-label" :for="'SwitchCheck1'+parseInt(y)+1"> Day &nbsp;{{ parseInt(y)+1}}&nbsp;</label>
                <input class="form-check-input" type="checkbox" role="switch" :id="parseInt(y)+1" v-if="x" checked @click="updateAssistance(userID, y, false)">
                <input class="form-check-input" type="checkbox" role="switch" :id="parseInt(y)+1" v-else  @click="updateAssistance(userID, y, true)">
              </div>
<!--              <input type="checkbox" class="form-check-input" :id="'inlineswitch'+parseInt(y)+1" v-if="x" checked @click="updateAssistance(userID, y, false)">-->
<!--              <input type="checkbox" class="form-check-input" :id="'inlineswitch'+parseInt(y)+1" v-else @click="updateAssistance(userID, y, true)">-->
            </span>
        </div>
      </td>

    </div>
  </BModal>
</template>

<style>
/* Lift SweetAlert2 toast away from the very bottom edge */
.swal-toast-raised {
  margin-bottom: 80px !important;
}
/* Read notifications appear subtly faded */
.notif-read {
  opacity: 0.6;
}
.notif-read:hover {
  opacity: 1;
}
</style>
